<template>
  <DSDrawer :visible="visible" :title="title" @close="onClose">
    <slot />
    <template #footer v-if="$slots.footer">
      <slot name="footer" />
    </template>
  </DSDrawer>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Drawer } from '@sohohouse/design-system'

const { mapActions: mapModalActions, mapGetters: mapModalGetters } = createNamespacedHelpers('ui/modals')

export default {
  components: {
    DSDrawer: Drawer
  },

  props: {
    name: {
      type: String,
      required: true
    },

    title: {
      type: String,
      default: ''
    }
  },

  methods: {
    ...mapModalActions(['close']),

    onClose () {
      this.close(this.name)
      this.$emit('close')
    }
  },

  computed: {
    ...mapModalGetters(['openModals']),

    visible () {
      return this.openModals.includes(this.name)
    }
  }
}
</script>
